import React, { ReactElement, useCallback, useState } from 'react';
import isEqual from 'lodash.isequal';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './index';

const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const [isFormVisible, setIsFormVisible] = useState(false);

    const handleFormShow = useCallback(
      () => {
        setIsFormVisible(true);
      },
      [],
    );

    const handleFormHide = useCallback(
      () => {
        setIsFormVisible(false);
      },
      [],
    );

    const injectedProps: InjectedProps = {
      isFormVisible,
      onFormShow: handleFormShow,
      onFormHide: handleFormHide,
    };

    return <Component {...props} {...injectedProps} />;
  };

  return React.memo(WithContainer, (prevProps, nextProps) => isEqual(prevProps, nextProps));
};

export { withContainer };
